export const ARCHIVE = 'ARCHIVE'
export const DEFAULT = 'DEFAULT'
